import React from 'react';
import PropTypes from 'prop-types';
import differenceInMilliseconds from 'date-fns/differenceInMilliseconds';
import parseISO from 'date-fns/parseISO';
import { PLAYER_CONTENT_KIND } from '../../player/constants';

const RETRY_TIMEOUT = 5000;

export class PlaybackSessionContainer extends React.PureComponent {
  static propTypes = {
    ID: PropTypes.string,
    sessionUrl: PropTypes.string,
    nextUpdate: PropTypes.string,
    error: PropTypes.any,
    isReadyToLoad: PropTypes.bool.isRequired,
    kind: PropTypes.string.isRequired,
    setID: PropTypes.func.isRequired,
    load: PropTypes.func.isRequired,
    episodeStart: PropTypes.func.isRequired,
    episodeEnd: PropTypes.func.isRequired,
    clipStart: PropTypes.func.isRequired,
    clipEnd: PropTypes.func.isRequired,
    setAutoPlay: PropTypes.func.isRequired,
    isClipEnded: PropTypes.bool.isRequired,
    isAutoPlay: PropTypes.bool.isRequired,
    videoLoaded: PropTypes.bool,
    prevVodContent: PropTypes.any,
    vodPayload: PropTypes.any,
    currentData: PropTypes.shape({
      channelID: PropTypes.string,
      episodeID: PropTypes.string,
      clipID: PropTypes.string,
    }).isRequired,
    children: PropTypes.node,
  };

  static defaultProps = {
    ID: null,
    sessionUrl: null,
    nextUpdate: null,
    error: null,
    children: null,
    videoLoaded: null,
  };

  errorCount = 0;
  updateTimer = null;

  componentDidMount() {
    this.configure();
  }

  componentWillReceiveProps(nextProps) {
    const getData = ({ channelID, episodeID, clipID }) => ({ channelID, episodeID, clipID });
    const { currentData } = nextProps;
    if (currentData) {
      const { currentData: oldData = {} } = this.props;

      if (
        currentData.channelID &&
        currentData.channelID !== 'vod' &&
        oldData.channelID === currentData.channelID
      ) {
        // we did not change channel
        if (oldData.clipID && oldData.clipID !== currentData.clipID) {
          this.props.clipEnd(getData(oldData));
        }

        if (oldData.episodeID && oldData.episodeID !== currentData.episodeID) {
          this.props.episodeEnd(getData(oldData));
        }
      }

      if (currentData.episodeID && currentData.episodeID !== oldData.episodeID) {
        if (!oldData.episodeID && !nextProps.prevVodContent.type.includes('VIRAL')) {
          this.setIsAutoPlay();
        }
        this.props.episodeStart(getData(currentData));
      }

      if (currentData.clipID && currentData.clipID !== oldData.clipID && nextProps.videoLoaded) {
        this.props.clipStart(getData(currentData));
      }

      if (
        currentData.channelID === 'viral' &&
        nextProps.isClipEnded &&
        !this.props.videoLoaded &&
        nextProps.videoLoaded
      ) {
        this.props.clipStart(getData(currentData));
      }

      if (oldData.channelID === 'viral' && oldData.channelID !== currentData.channelID) {
        this.props.clipEnd(getData(oldData));
      }
    }
  }

  componentDidUpdate(prevProps) {
    this.configure(prevProps);
  }

  setIsAutoPlay = () => {
    const { kind } = this.props;
    if (kind === PLAYER_CONTENT_KIND.LINEAR_CHANNEL) {
      this.props.setAutoPlay({ isAutoPlay: true });
    }
  };

  registerUpdate() {
    const { nextUpdate, sessionUrl, load } = this.props;

    if (sessionUrl) {
      this.errorCount = 0;
      if (this.updateTimer) {
        clearTimeout(this.updateTimer);
      }
      const diff = differenceInMilliseconds(parseISO(nextUpdate), new Date());
      this.updateTimer = setTimeout(() => load(), diff);
    }
  }

  handleError() {
    const { sessionUrl, load, error } = this.props;

    this.errorCount += 1;

    if (this.errorCount < 5) {
      if (this.updateTimer) {
        clearTimeout(this.updateTimer);
      }
      console.warn('Playback session error, retrying on 5 seconds', sessionUrl, error);
      this.updateTimer = setTimeout(() => load(), RETRY_TIMEOUT);
    } else {
      console.warn('Playback session update stalled due large amount of errors');
    }
  }

  configure(prevProps = {}) {
    const { ID, nextUpdate, error, setID } = this.props;

    if (nextUpdate && nextUpdate !== prevProps.nextUpdate) {
      this.registerUpdate();
    }

    if (error) {
      this.handleError();
    }
  }

  render() {
    return this.props.children;
  }
}
